// پرچمِ «حالت دمو»: با EXPO_PUBLIC_DEMO_MODE=1 روشن میشه (نگاه کن به scripts/demo-web.mjs).
// وقتی روشنه، repoها به‌جای Supabase از src/core/demo/store.ts می‌خونن/می‌نویسن —
// هیچ درخواستی به بک‌اند واقعی نمیره.
//
// چرا این typeof: `process` فقط در Node و بیلدِ Expo وجود داره. مرورگر اصلاً
// نداردش و **خودِ خواندنش** ReferenceError می‌ده. چون این خط در بدنه‌ی ماژول
// اجرا می‌شه، اون خطا کلِ سایت رو قبل از اولین رندر می‌کشت و صفحه سفید بالا
// می‌آمد. گاردِ dependency-cruiser این رو نمی‌گیره: اون importها رو می‌بینه،
// نه متغیرهای سراسری.
//
// وب فعلاً حالت دمو نداره و همیشه false می‌گیره. اگه روزی لازم شد، راهش
// خواندنِ import.meta.env در همین‌جا **نیست** (Metro اون نحو رو نمی‌فهمه) —
// راهش افزودنِ یک فیلد به CoreDeps در ports.ts است، مثل بقیه‌ی نیازهای پلتفرمی.
const expoDemoFlag = typeof process === 'undefined'
  ? undefined
  : process.env?.EXPO_PUBLIC_DEMO_MODE;

export const isDemoMode = expoDemoFlag === '1';

/**
 * زبانِ دادهٔ ساختگیِ حالتِ دمو — `fa` (پیش‌فرض) یا `en`.
 *
 * ═══ چرا لازم شد ═══
 *
 * فیکسچرهای دمو فارسی‌اند و برای نشان‌دادنِ اپ همان درست است. ولی همان‌ها
 * منبعِ تصویرهای صفحه‌ی App Store هم هستند (`scripts/screenshots.mjs`)، و
 * آن صفحه انگلیسیِ کاناداست: تصویرِ پر از متنِ فارسی به بیننده می‌گوید این
 * یک اپِ فارسی‌زبان است.
 *
 * ⚠️ عمداً از `getLocale()` خوانده نمی‌شود. فیکسچرها موقعِ ساختِ استور
 * ارزیابی می‌شوند، که ممکن است قبل از تعیین‌شدنِ زبانِ رابط باشد — آن‌وقت
 * نتیجه به ترتیبِ بارگذاری وابسته می‌شد، یعنی گاهی درست و گاهی نه. یک
 * متغیرِ محیطی صریح است و همیشه یک جواب می‌دهد.
 *
 * پیش‌فرض `fa` است تا هیچ‌کس که امروز دمو را باز می‌کند تغییری نبیند.
 */
export type DemoLang = 'fa' | 'en';

const expoDemoLang = typeof process === 'undefined'
  ? undefined
  : process.env?.EXPO_PUBLIC_DEMO_LANG;

export const demoLang: DemoLang = expoDemoLang === 'en' ? 'en' : 'fa';
